var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 8,
    height: 12,
    viewBox: "0 0 8 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-85.333)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(85.333)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#767676",
    d: "M89.333,0a4,4,0,0,0-3.52,5.9l3.3,5.97a.25.25,0,0,0,.437,0l3.3-5.972A4,4,0,0,0,89.333,0Zm0,6a2,2,0,1,1,2-2A2,2,0,0,1,89.333,6Z",
    transform: "translate(-85.333)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIcon);
export default __webpack_public_path__ + "static/media/location-icon.828ad2ea.svg";
export { ForwardRef as ReactComponent };